/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderListQuery
 */
export interface ProviderListQuery {
    /**
     * 
     * @type {boolean}
     * @memberof ProviderListQuery
     */
    showDisabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProviderListQuery
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof ProviderListQuery
     */
    limit?: number;
}

export function ProviderListQueryFromJSON(json: any): ProviderListQuery {
    return ProviderListQueryFromJSONTyped(json, false);
}

export function ProviderListQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderListQuery {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showDisabled': !exists(json, 'showDisabled') ? undefined : json['showDisabled'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function ProviderListQueryToJSON(value?: ProviderListQuery | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showDisabled': value.showDisabled,
        'offset': value.offset,
        'limit': value.limit,
    };
}


